
import { SiriusAppModule } from 'sirius-framework';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/modules/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { InnerMenuOldProcessRoutingModule } from './inner-menu-oldprocess.routing.module';

import { InnerMenuOldProcessComponent } from './inner-menu-oldprocess.component';
import { OldProcessComponent } from './components/oldprocess/oldprocess.component';

import { InnerMenuOldProcessService } from './inner-menu-oldprocess.service';
import { NgModule } from '@angular/core';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        InnerMenuOldProcessRoutingModule       
    ],
    declarations: [
        InnerMenuOldProcessComponent,
        OldProcessComponent
    ],
    providers: [
        InnerMenuOldProcessService
    ]
})
export class InnerMenuOldProcessModule extends SiriusAppModule { }
